import { useEffect } from "react";
import { useImagesPanelStockStore } from "../store";

export const useResetStore = () => {
  const reset = useImagesPanelStockStore((s) => s.reset);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);
};
